<template>
    <button @click="toggle()"><slot /></button>
</template>

<script setup>
import { useMobileSidebar } from '@/composables/mobileSidebar.js';

const { toggle } = useMobileSidebar();
</script>
